import { useCallback, useEffect, useMemo, useState } from 'react'

import { useBucket } from '@mc/experiments-react'
import { categoryAccessor, subcategoryAccessor } from '@mc/user-data'
import { trackExperimentViewed } from '@mc/track-event'

const PRESELECT_QUIZ_EXPERIMENT_KEY = 'pen-4674_v1'

const usePreselectQuizBucket = () => {
  const bucket = useBucket(PRESELECT_QUIZ_EXPERIMENT_KEY)
  const isPreselectQuizVariant = bucket === 'variant_1'
  return { isPreselectQuizVariant }
}

export const usePreselectQuizExperiment = () => {
  const [mounted, setMounted] = useState(false)
  const { isPreselectQuizVariant } = usePreselectQuizBucket()

  useEffect(() => {
    setMounted(true)
  }, [])

  const hasInterestsAvailable = useMemo(
    () => mounted && categoryAccessor.hasInterests(),
    [mounted],
  )

  const trackPreselectQuizEV = useCallback(() => {
    if (hasInterestsAvailable) {
      trackExperimentViewed(PRESELECT_QUIZ_EXPERIMENT_KEY)
    }
  }, [hasInterestsAvailable])

  const categoryInterests = useMemo(
    () =>
      isPreselectQuizVariant && mounted
        ? categoryAccessor.getAllInterestIds()
        : [],
    [isPreselectQuizVariant, mounted],
  )
  const subcategoryInterests = useMemo(
    () =>
      isPreselectQuizVariant && mounted
        ? subcategoryAccessor.getAllInterestIds()
        : [],
    [isPreselectQuizVariant, mounted],
  )

  return {
    trackPreselectQuizEV,
    isPreselectQuizVariant,
    categoryInterests,
    subcategoryInterests,
  }
}
